<template>
  <v-form>
    <v-container>
      <v-content v-if="!this.token">

<v-row>
          <v-col cols="12" align="center">
            <v-img src="https://yazilimsalcozumler.com/maxisu.png" 
            width="275" height="70"></v-img>
            <!-- <span class="title">Pump Selection</span> -->
          </v-col>
</v-row>

<v-card :loading="isLoading"
style="margin-top:20px"
    class="mx-auto"
    max-width="400"
    outlined
  >
  <v-row style="min-height:20px">
  </v-row>
 <!-- <v-row>
 <v-col  cols="12" align="center">
      <span class="headline">Login</span>
 </v-col>
 </v-row> -->
         
         <v-row>
        <v-col align="center"  cols="12" >
          <v-text-field v-model="loginCredentials.username" style="width:300px" suffix label="Username" required></v-text-field>
        </v-col>
         </v-row>
        
      
      <v-row>
        <v-col align="center"  cols="12" >
          <v-text-field style="width:300px"
            v-model="loginCredentials.password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            @click:append="show1 = !show1"
          ></v-text-field> 
          
        </v-col>
      </v-row>   

      

      <v-row>
        <v-col align="center" cols="12" md="12" lg="12" sm="12">
      <!-- <div class="my-2"> -->
        <v-btn style="width:90%;padding:20px" x-large color="primary" @click="login"> Login </v-btn>
         <!-- <v-btn x-large color="primary" @click="kontrol"> Giris Kontrol  </v-btn> -->
      <!-- </div> -->
        </v-col>

      </v-row>

  <v-row style="min-height:20px">
  </v-row>
</v-card>
      </v-content>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "Login",

  data: () => ({
    isLoading: false,
    admin: false,
    show1: false,
    loginCredentials : {
    username: "adminmaxisu",
    password: "pass1"
    },
    token: "",
    username: "",
  }),
mounted: function() {
    if(localStorage.admin){
      this.admin = localStorage.admin
    }

    if(localStorage.token){
      this.token = localStorage.token
    }

    if(localStorage.username){
      this.username = localStorage.username
    }
  },
  watch: {
    admin(newValue){
      localStorage.admin = newValue
    },
    username(newValue){
      localStorage.username = newValue
    },
    token(newValue){
      localStorage.token = newValue
      if (localStorage.admin){
        // this.$router.push('/pumps').catch(err => {  })
        window.location = "/pumps"
      }else{
        window.location = "/find"
        // this.$router.push('/find').catch(err => {  })
      }
    }
  }, 
  methods: {
    login: function() {
    this.isLoading = true;
      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // url: this.$API_URL.replace("api","") + "login",
        url: this.$API_URL.replace("/api/","/") + "login",
        data: this.loginCredentials
      })
        .then(response => { 
          if (response.data.token != null){

            this.isLoading = false
            this.token = response.data.token
            this.username = response.data.username
            // this.setToken()
            this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
            if(response.data.admin == true)
              this.admin = true
            else
              this.admin = false

            // if (response.data.admin == true){ // goto pumps.
            //   this.$router.push('/pumps').catch(err => {  })
            // } else { // goto find pumps.
            //   this.$router.push('/find').catch(err => {  })
            // }
          }
          
          console.log(response.data)
          // if (response.data == "1")
            //  window.history.go(-1)
        })
        .catch(function(error) {
          console.log(error);

          this.isLoading = false
        });
    
    },

    kontrol: function() {
      this.$http({
        method: "get",
        headers: { "Content-Type": "application/x-www-form-urlencoded",
        // "Authorization" : `Bearer ${this.token}`
        },
        url: this.$API_URL + "api/user",
        data: this.loginCredentials
      })
        .then(function(response) {
          console.log(response.data)
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
